<ng-container *ngIf="hasPendingChangeRequests$ | async">
  <div class="banner-container">
    <glxy-alert type="info" [showAction]="true" actionTitle="Review" (actionClick)="routeToSpendChangeRequests()">
      You have pending spend change requests
    </glxy-alert>
  </div>
</ng-container>
